import React from "react";
import styles from "./entryBox.scss";
import ReactGA from "react-ga4";
import { ModuleNameHr, PageRoute } from "../../../models";
import history from "../../../history";
import { Link } from "react-router-dom";

export const RealEstateWidget = ({ category, style = {}, label, isSearchPage = false }) => {

  const handleClick = () => {
    ReactGA.event({
      category: "Kretanje cijena nekretnina",
      action: "Click",
      label
    });
  };

  const base = `/${ModuleNameHr.realEstate}${PageRoute.realEstatePrices}`;
  const link = category ? `${base}?kategorija=${category}` : base


  return (
    <div className={`${styles.content} ${isSearchPage ? styles.searchPageContent : ""}`} style={style}>
      <div>
        <h3 className={`${styles.title} ${isSearchPage ? styles.searchPageTitle : ""}`}>{"Kako se kreću cijene nekretnina?"}</h3>
        <p className={`${styles.description} ${isSearchPage ? styles.searchPageDescription : ""}`}>
          {"Pogledajte cijene nekretnina na svim lokacijama u Hrvatskoj."}
        </p>
      </div>
      <Link to={link}>
        <button type="button" className={`${styles.button} ${isSearchPage ? styles.searchPageButton : ""}`} onClick={handleClick}>
          {"Pogledaj"}
        </button>
      </Link>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/containers/ModulePage/RealEstatePricesEntryBox/RealEstateWidget.tsx